import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { MDBDataTable } from 'mdbreact';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import axios from 'axios';
import { FormCheck } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Pagination, InputGroup, FormControl } from 'react-bootstrap';
import { baseUrl, ROUTE_BASE_URL } from '../../../api/common';
import {
  convertDBDate,
  membershipApplicationStatisticscardData,
} from '../common';
import { useUser } from '../../AdminUsers/UserContext';
import Datepicker from '../../common/datepicker';

const MembershipApplicationReports = () => {
  const { checkPermission } = useUser();
  const [totalRecords, setTotalRecords] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');

  const [membershipPackageData, setMembershipPackageData] = useState([]);

  const fetchMembershipPackageData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/get_application`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('access_token'),
        },
      });

      if (response.data.status) {
        const data = response.data.data.map(item => ({
          ...item,
          id: item.id,
          title: item.application_name || 'N/A',
          slug: `${ROUTE_BASE_URL}/membership-application/${item.slug}` ||
            'N/A',
          count: item.application_count || 'N/A',
        }));
        setMembershipPackageData(data);
      } else {
        console.error('Error: Failed to fetch user data');
      }
    } catch (error) {
      console.error('Error fetching users data:', error);
    }
  };

  const [selectedRows, setSelectedRows] = useState([]);
  const handleRowSelect = id => {
    setSelectedRows(
      prev =>
        prev.includes(id) ? prev.filter(rowId => rowId !== id) : [...prev, id]
    );
  };

  function getApplicationStatusClass(type) {
    switch (type) {
      case 1:
        return 'status-all-applications';
      case 2:
        return 'status-pending-clarification';
      case 3:
        return 'status-pending-actions';
      case 4:
        return 'status-pending-resubmission';
      case 6:
        return 'status-rejected';
      case 10:
        return 'status-payment-status';
      case 12:
        return 'status-membership-allotted';
      default:
        return 'text-blue';
    }
  }

  const [applicationMembersData, setApplicationMembersData] = useState([]);
  const membersTableData = {
    columns: [
      // {
      //   label: (
      //     <FormCheck
      //       type="checkbox"
      //       onClickCapture={e => e.stopPropagation ()}
      //       onChange={e =>
      //         setSelectedRows (
      //           e.target.checked ? applicationMembersData.map (d => d.id) : []
      //         )}
      //     />
      //   ),
      //   field: 'select',
      //   sort: false,
      //   attributes: {
      //     style: {width: '2%', textAlign: 'center'},
      //   },
      // },
      {
        label: 'S.No',
        field: 'sno',
        attributes: {
          style: { width: '4%' },
        },
      },
      {
        label: 'Name',
        field: 'name',
        width: 150,
        attributes: {
          'aria-controls': 'DataTable',
          'aria-label': 'Name',
          style: { width: '12%' },
        },
      },
      {
        label: 'Membership Type',
        field: 'application_name',
        width: 150,
        attributes: {
          'aria-controls': 'DataTable',
          'aria-label': 'Name',
          style: { width: '12%' },
        },
      },
      {
        label: 'Application No',
        field: 'application_no',
        // sort: 'disabled',
        // width: 100,
        attributes: {
          style: { width: '8%' },
        },
      },
      {
        label: 'Member ID',
        field: 'memberid',
        // sort: 'disabled',
        // width: 150,
        attributes: {
          style: { width: '8%' },
        },
      },
      {
        label: 'Mobile',
        field: 'mobile',
        sort: 'asc',
        // width: 100,
        attributes: {
          style: { width: '10%' },
        },
      },
      {
        label: 'Email',
        field: 'email',
        // width: 200,
        attributes: {
          style: { width: '10%' },
        },
      },
      {
        label: 'Status',
        field: 'status',
        // width: 150,
        attributes: {
          'aria-controls': 'DataTable',
          'aria-label': 'Name',
          style: { width: '8%' },
        },
      },
      {
        label: 'Application Date',
        field: 'date',
        // width: 150,
        attributes: {
          'aria-controls': 'DataTable',
          'aria-label': 'Name',
          style: { width: '10%' },
        },
      }
    ],
    rows: applicationMembersData &&
      applicationMembersData.map((data, index) => ({
        // select: (
        //   <FormCheck
        //     type="checkbox"
        //     checked={selectedRows.includes (data.id)}
        //     onClickCapture={e => e.stopPropagation ()}
        //     onChange={() => handleRowSelect (data.id)}
        //   />
        // ),
        sno: (currentPage - 1) * rowsPerPage + index + 1,
        // sno: index + 1,
        name:data.first_name || data.middle_name || data.last_name
          ? `${data.first_name || ""} ${data.middle_name || ""} ${data.last_name || ""}`
              .trim()
              .replace(/\s+/g, " ")
          : "N/A",
        application_name: data.application_name || 'N/A',
        applicationid: data.application_id || 'N/A',
        email: data.email || 'N/A',
        mobile: data.mobile || 'N/A',
        memberid: data.membership_no || 'N/A',
        application_no: data.application_no || 'N/A',
        status: <span className={getApplicationStatusClass(data.application_status)}>{data.status_name || 'N/A'}</span>,
        date: convertDBDate(data.member_reg_date) || 'N/A'
      })),
  };

  const [applicationFilterOpen, setApplicationFilterOpen] = useState(false);

  const applicationFilterToggle = () =>
    setApplicationFilterOpen(prevState => !prevState);

  const [statusFilterOpen, setStatusFilterOpen] = useState(false);
  const [selectedApplication, setSelectedApplication] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedApplicationId, setSelectedApplicationId] = useState('');
  const [selectedStatusId, setSelectedStatusId] = useState('');

  const statusFilterToggle = () =>
    setStatusFilterOpen(prevState => !prevState);

  const handleApplicationFilter = application => {
    setSelectedApplicationId(application.id);
    setSelectedApplication(application.application_name);
  };

  const handleApplicationStatusFilter = status => {
    setSelectedStatusId(status.id);
    setSelectedStatus(status.title);
  };

  const handleClearFilter = () => {
    setSelectedApplicationId('');
    setSelectedStatusId('');
    setSelectedApplication('');
    setSelectedStatus('');
    setStartDate(null);
    setEndDate(null);
  };

  const [exportToExcelStatus, setExportToExcelStatus] = useState(false);
  const exportToExcel = async(
    id = selectedApplicationId,
    status = selectedStatusId,
    limitValue = rowsPerPage,
    limitoffset = currentPage,
    searchTerm = searchQuery,
    from_date = startDate,
    to_date = endDate
  ) => {
    setExportToExcelStatus(true);
    try {
      const response = await axios.post(
        `${baseUrl}/api/application_report`,
        {
          application_id: id,
          application_status: status,
          // limit_value: "",
          // limit_offset: "",
          search: searchTerm,
          from_date: from_date || '',
          to_date: to_date || '',
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: localStorage.getItem('access_token'),
          },
        }
      );

      if (response.data.status) {
        console.log(response.data.data,"Report Data");
        if( response.data.data.length>0){
        const ws = XLSX.utils.json_to_sheet(
          response.data.data
            .map((data, index) => ({
              'S.No': index + 1,
              // Salutation: data.salutation || 'N/A',
              Name: data.first_name || data.middle_name || data.last_name
                    ? `${data.first_name || ""} ${data.middle_name || ""} ${data.last_name || ""}`
                        .trim()
                        .replace(/\s+/g, " ")
                    : "N/A",
              "Father's Name": data.father_name || 'N/A',
              DOB: convertDBDate(data.dob),
              Age: data.age || 'N/A',
              Nationality: data.nationality || 'N/A',
              Gender: data.gender || 'N/A',
              'Membership Type': data.application_name || 'N/A',
              'Application No': data.application_no || 'N/A',
              'Member ID': data.membership_no || 'N/A',
              'Mobile Code': data.mobile_code || 'N/A',
              Mobile: data.mobile || 'N/A',
              Email: data.email || 'N/A',
              'Street Address 1': data.street_line1 || 'N/A',
              'Street Address 2': data.street_line2 || 'N/A',
              City: data.city || 'N/A',
              State: data.state_name || 'N/A',
              Country: data.country_name || 'N/A',
              'Postal/Zip Code': data.pin || 'N/A',
              Landline: data.landline || 'N/A',
              'STD Code': data.stdcode || 'N/A',
              'Education - UG College': data.edu_undergrad_college || 'N/A',
              'Education - UG University': data.edu_undergrad_university || 'N/A',
              'Education - UG Year': data.edu_undergrad_year || 'N/A',
              'Education - PG Degree': data.edu_postgrad_degree || 'N/A',
              'Education - PG College': data.edu_postgrad_college || 'N/A',
              'Education - PG University': data.edu_postgrad_university || 'N/A',
              'Education - PG Year': data.edu_postgrad_year || 'N/A',
              'MCI Council Number': data.mci_council_number || 'N/A',
              'MCI Council State': data.mci_council_state_name || 'N/A',
              'IMR Registration No': data.imr_reg_no || 'N/A',
              'ASI Membership No': data.asi_membership_no || 'N/A',
              'ASI State': data.asi_state_name || 'N/A',
              'Profile Image': data.profile || 'N/A',
              'NMC Certificate': data.mci_certificate || 'N/A',
              'ASI Membership Certificate': data.asi_member_certificate || 'N/A',
              'PG Degree Certificate': data.pg_degree_certificate || 'N/A',
              'Letter from HOD ': data.letter_hod || 'N/A',
              'Active License for Practicing Surgeons': data.active_license || 'N/A',
              'Other International Organization': data.other_inter_organisation || 'N/A',
              'Other International Organization Value': data.other_inter_organisation_value || 'N/A',
              'Application Date': convertDBDate(data.member_reg_date) || 'N/A',
              Status: data.status_name || 'N/A',
              'Login Activity': convertDBDate(data.last_login) || 'N/A',
            }))
        );    
        const csv = XLSX.utils.sheet_to_csv(ws);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, 'Membership-Application-Report.csv');
      }
      } else {
        console.error('Error: Failed to fetch user data');
      }
    } catch (error) {
      console.error('Error fetching users data:', error);
    } finally {
      setExportToExcelStatus(false);
    }
    // const ws = XLSX.utils.json_to_sheet(
    //   applicationMembersData
    //     .map((data, index) => ({
    //       'S.No': index + 1,
    //       Name: `${data.first_name} ${data.last_name}` || 'N/A',
    //       "Father's Name": data.father_name || 'N/A',
    //       DOB: convertDBDate(data.dob),
    //       Age: data.age || 'N/A',
    //       Nationality: data.nationality || 'N/A',
    //       Gender: data.gender || 'N/A',
    //       'Membership Type': data.application_name || 'N/A',
    //       'Application No': data.application_no || 'N/A',
    //       'Member ID': data.membership_no || 'N/A',
    //       Mobile: data.mobile || 'N/A',
    //       Email: data.email || 'N/A',
    //       'Street Address 1': data.street_line1 || 'N/A',
    //       'Street Address 2': data.street_line2 || 'N/A',
    //       City: data.city || 'N/A',
    //       State: data.state_name || 'N/A',
    //       Country: data.country_name || 'N/A',
    //       'Postal/Zip Code': data.pin || 'N/A',
    //       Landline: data.landline || 'N/A',
    //       'STD Code': data.stdcode || 'N/A',
    //       'Education - UG College': data.edu_undergrad_college || 'N/A',
    //       'Education - UG University': data.edu_undergrad_university || 'N/A',
    //       'Education - UG Year': data.edu_undergrad_year || 'N/A',
    //       'Education - PG Degree': data.edu_postgrad_degree || 'N/A',
    //       'Education - PG College': data.edu_postgrad_college || 'N/A',
    //       'Education - PG University': data.edu_postgrad_university || 'N/A',
    //       'Education - PG Year': data.edu_postgrad_year || 'N/A',
    //       'MCI Council Number': data.mci_council_number || 'N/A',
    //       'MCI Council State': data.mci_council_state_name || 'N/A',
    //       'IMR Registration No': data.imr_reg_no || 'N/A',
    //       'ASI Membership No': data.asi_membership_no || 'N/A',
    //       'ASI State': data.asi_state_name || 'N/A',
    //       'Other International Organization': data.other_inter_organisation ||
    //         'N/A',
    //       'Other International Organization Value': data.other_inter_organisation_value ||
    //         'N/A',
    //       'Application Date': convertDBDate(data.member_reg_date) || 'N/A',
    //       Status: data.status_name || 'N/A',
    //       'Login Activity': '--',
    //     }))
    // );
    // const csv = XLSX.utils.sheet_to_csv(ws);
    // const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    // saveAs(blob, 'MembersData.csv');
  };

  const [selectedTableEntry, setSelectedTableEntry] = useState(10);

  const [tableEntriesOpen, setTableEntriesOpen] = useState(false);

  const tableEntriesToggle = () =>
    setTableEntriesOpen(prevState => !prevState);

  const handlePageChange = newPage => {
    setCurrentPage(newPage);
  };

  const handleEntriesChange = entries => {
    const newLimit = parseInt(entries, 10);
    setSelectedTableEntry(newLimit);
    setRowsPerPage(newLimit);
    setCurrentPage(1);
  };

  const handleSearch = event => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const clearSearch = () => {
    setSearchQuery('');
  };

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [tableIsLoading, setTableIsLoading] = useState(false);
  const fetchApplicationMembersData = async (
    id = selectedApplicationId,
    status = selectedStatusId,
    limitValue = rowsPerPage,
    limitoffset = currentPage,
    searchTerm = searchQuery,
    from_date = startDate,
    to_date = endDate
  ) => {
    setTableIsLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/api/application_report`,
        {
          application_id: id,
          application_status: status,
          limit_value: limitValue,
          limit_offset: (limitoffset - 1) * limitValue,
          search: searchTerm,
          from_date: from_date || '',
          to_date: to_date || '',
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: localStorage.getItem('access_token'),
          },
        }
      );

      if (response.data.status) {
        setApplicationMembersData(response.data.data);
        setTotalRecords(response.data.total);
      } else {
        console.error('Error: Failed to fetch user data');
      }
    } catch (error) {
      console.error('Error fetching users data:', error);
    }finally {
      setTableIsLoading(false);
    }
  };

  // Check Admin User Permission
  const [checkUserLoading, setCheckUserLoading] = useState(false); 
  const fetchPermission = async () => {
    setCheckUserLoading(true);
    try {
      const hasPermission = await checkPermission("Application Reports", "view");
      if (!hasPermission) return;
    } catch (error) {
      console.error("Error fetching super specialty data:", error);
    }finally{
      setCheckUserLoading(false);
    }
  };
  useEffect(() => {
    fetchPermission();
  }, []);

  useEffect(() => {
    fetchMembershipPackageData();
  }, []);

  useEffect(
    () => {
      fetchApplicationMembersData(
        selectedApplicationId,
        selectedStatusId,
        rowsPerPage,
        currentPage,
        searchQuery,
        startDate,
        endDate
      );
    },
    [
      currentPage,
      rowsPerPage,
      searchQuery,
      selectedApplicationId,
      selectedStatusId,
      startDate,
      endDate,
    ]
  );

  return (
    <>
    {checkUserLoading? (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "500px" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
      ) : (
      <div className="container-fluid">
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h1>Membership Application Report</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={`${ROUTE_BASE_URL}/`}>Amasi</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Membership Application Report
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
        <div className="row clearfix table_scrool">
          <div className="col-lg-12">
            <div className="card">
              {/* <div className="header"><h2>Recent Member</h2></div> */}
              <div className="body">
                <div className="row clearfix">
                  <div className="col-md-12 col-sm-12 recent-member-btns">
                    <button
                      // disabled={selectedRows.length < 1}
                      onClick={() => exportToExcel()}
                      type="button"
                      disabled={exportToExcelStatus}
                      className="btn btn-info  mb-2 mr-1"
                    >
                      <i class="fa fa-file" aria-hidden="true" />
                      {' '}
                      <span className="flo-txt-none"> {exportToExcelStatus ? 'Exporting...' : 'Export'}  
                        {exportToExcelStatus && <i className="fa fa-spinner fa-spin" aria-hidden="true"/>}
                      </span>
                    </button>
                    <div className="btn-default reports_page mb-2 mr-1">
                      <Dropdown
                        isOpen={applicationFilterOpen}
                        toggle={applicationFilterToggle}
                      >
                        <DropdownToggle caret className="btn-default btn btn-primary m-0">
                          {selectedApplication || 'Filter by Application'}
                        </DropdownToggle>
                        <DropdownMenu container="body">
                          {membershipPackageData &&
                            membershipPackageData
                              .filter(member =>
                                [1, 2, 3, 4].includes(member.id)
                              )
                              .map(action => (
                                <DropdownItem
                                  className={`${selectedApplication === action.application_name && 'active'}`}
                                  key={action.id}
                                  onClick={() => handleApplicationFilter(action)}
                                >
                                  {action.application_name}
                                </DropdownItem>
                              ))}
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                    <div className="btn-default reports_page mb-2 mr-1">
                      <Dropdown
                        isOpen={statusFilterOpen}
                        toggle={statusFilterToggle}
                      >
                        <DropdownToggle caret className="btn-default btn btn-primary m-0">
                          {selectedStatus || 'Filter by Status'}
                        </DropdownToggle>
                        <DropdownMenu container="body">
                          {membershipApplicationStatisticscardData &&
                            membershipApplicationStatisticscardData
                              .filter(action => ![13].includes(action.id))
                              .map(action => (
                                <DropdownItem
                                  className={`${selectedStatus === action.title && 'active'}`}
                                  key={action.id}
                                  onClick={() =>
                                    handleApplicationStatusFilter(action)}
                                >
                                  {action.title}
                                </DropdownItem>
                              ))}
                        </DropdownMenu>
                      </Dropdown>
                    </div>

                    <button
                      onClick={() => handleClearFilter()}
                      className="btn btn-danger    mb-2 mr-1"
                    >
                      <i className="fa fa-trash-o" aria-hidden="true" />
                      {' '}{' '}
                      <span className="flo-txt-none">Clear Filter</span>
                    </button>
                  </div>
                </div>
                <div className="row search_entries">
                  <div className="col-md-12 col-sm-12 search_entries">
                    <div className="entries">
                      <p>Show entries: </p>
                      <div className="btn-default mb-2 ml-1">
                        <Dropdown
                          isOpen={tableEntriesOpen}
                          toggle={tableEntriesToggle}
                        >
                          <DropdownToggle caret className="btn-default m-0">
                            {selectedTableEntry || 'Filter by Status'}
                          </DropdownToggle>
                          <DropdownMenu container="body">
                            {[5, 10, 20, 50].map(option => (
                              <DropdownItem
                                key={option}
                                onClick={() => handleEntriesChange(option)}
                              >
                                {option}
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                    </div>
                    <div>
                      <div
                        className="input-daterange input-group"
                        data-provide="datepicker"
                      >
                        <Datepicker
                          className="input-sm form-control"
                          selectedDate={startDate}
                          onDateChange={setStartDate}
                          placeholder="Start Date"
                        />
                        <span className="input-group-addon   ">to</span>
                        <Datepicker
                          className="input-sm form-control"
                          selectedDate={endDate}
                          onDateChange={setEndDate}
                          placeholder="End Date"
                        />
                      </div>
                    </div>
                    <div>
                      <InputGroup className="mb-3" style={{ position: 'relative' }}>
                        <FormControl
                          placeholder="Search ..."
                          value={searchQuery}
                          onChange={handleSearch}
                        />
                        {searchQuery &&
                          <span
                            className="clear-icon"
                            onClick={clearSearch}
                            style={{
                            
                            }}
                          >
                            <i
                              className="fa fa-times-circle"
                              aria-hidden="true"
                            />
                          </span>}
                      </InputGroup>
                    </div>

                  </div>
                </div>
                <div className="table-responsive">
                  {tableIsLoading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                  <>  
                  <MDBDataTable
                    noBottomColumns
                    className="table table-hover js-basic-example dataTable table-custom spacing5 check-box-custom"
                    entries={rowsPerPage}
                    data={membersTableData}
                    sortRows={["title"]}
                    paging={false}
                    searching={false}
                  />
                  <Pagination className="justify-content-center">
                    <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                      Previous
                    </Pagination.Prev>
                    {(() => {
                      const totalPages = Math.ceil(totalRecords / rowsPerPage)
                      const maxPagesToShow = 5
                      let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2))
                      let endPage = startPage + maxPagesToShow - 1
                      if (endPage > totalPages) {
                        endPage = totalPages
                        startPage = Math.max(1, endPage - maxPagesToShow + 1)
                      }
                      return [...Array(endPage - startPage + 1)].map((_, index) => {
                        const pageNumber = startPage + index
                        return (
                          <Pagination.Item
                            key={pageNumber}
                            active={pageNumber === currentPage}
                            onClick={() => handlePageChange(pageNumber)}
                          >
                            {pageNumber}
                          </Pagination.Item>
                        )
                      })
                    })()}
                    <Pagination.Next
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === Math.ceil(totalRecords / rowsPerPage)}
                    >
                      Next
                    </Pagination.Next>
                  </Pagination></>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>)}
    </>
  );
};
export default MembershipApplicationReports;
